export enum CincClientType {
    Legacy = "0",
    Partnership = "1",
    Prime = "2"
}
